export const allRole = ['ROLE_EDITEUR', 'ROLE_ADMIN', 'ROLE_UTILISATEUR']
export const canDeleteEdit = ['ROLE_EDITEUR', 'ROLE_ADMIN']
export const canRead = ['ROLE_UTILISATEUR']
export const defaultStyle = {
  justifyContent: 'flex-start',
  fontWeight: 'normal',
  fontStyle: 'normal',
  fontSize: '12px',
  color: '#000000',
  backgroundColor: '#FFFFFF',
  fontFamily: 'Arial, Helvetica, sans-serif',
  borderStyle: 'solid',
  borderColor: '#000',
  borderTop: 'none',
  borderRight: 'none',
  borderBottom: 'none',
  borderLeft: 'none',
  borderWidth: '0.0625rem'
}
export const defaultHeaderStyle = {
  justifyContent: 'flex-start',
  fontWeight: 'bold',
  fontStyle: 'normal',
  fontSize: '14px',
  color: 'color: #2b3085;',
  backgroundColor: '#f2f7fa',
  fontFamily: '"Open sans", Arial, sans-serif',
  borderStyle: 'solid',
  borderColor: '#2b3085',
  borderTop: 'none',
  borderRight: 'none',
  borderBottom: 'none',
  borderLeft: 'none',
  borderWidth: '0.0625rem'
}

export const defaultContainerStyle = {
  // marginLeft: '12px',
  // marginRight: '12px',
  // marginBottom: '50px'
}

export const fontSizes = ['8', '9', '10', '11', '12', '14', '16', '18', '20', '22', '24', '26', '28', '36', '48', '72']
export const fontSizesCahier = ['8', '9', '10', '11', '12', 'default', '16', '18', '20', '22', '24', '26', '28', '36']

const defaultHeaderBlocStyle = {
  column: {
    fontSize: '14px',
    fontFamily: 'Arial, Helvetica, sans-serif',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000',
    justifyContent: 'flex-end'
  },
  value: {
    fontSize: '14px',
    fontFamily: 'Arial, Helvetica, sans-serif',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000',
    justifyContent: 'flex-start'

  }
}

export const defaultFicheLayout = [
  // {
  //   type: 'header',
  //   style: { ...defaultHeaderBlocStyle },
  //   childElements: [
  //     {
  //       type: 'colonne',
  //       class: 'col',
  //       style: null,
  //       childElements: [
  //         {
  //           type: 'header',
  //           style: { ...defaultHeaderBlocStyle },
  //           childElements: [
  //             {
  //               key: 'H1',
  //               titre: 'Dénomination'
  //             }
  //           ]
  //         }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   type: 'fiche_data',
  //   style: { ...defaultHeaderBlocStyle },
  //   childElements: [
  //     {
  //       type: 'colonne',
  //       class: 'col-12',
  //       style: null,
  //       childElements: [
  //         {
  //           type: 'fiche_data',
  //           style: { ...defaultHeaderBlocStyle },
  //           childElements: [
  //             {
  //               key: 'H0',
  //               titre: 'Code'
  //             }
  //           ]
  //         }
  //       ]
  //     }
  //   ]
  // },
  {
    type: 'conteneur',
    style: {...defaultContainerStyle},
    childElements: [
      {
        type: 'colonne',
        class: 'col-12',
        style: { ...defaultHeaderBlocStyle },
        childElements: [
          {
            type: 'drop',
            style: { ...defaultHeaderBlocStyle },
            childElements: [
              {
                key: 'H1',
                titre: 'Dénomination'
              }
            ]
          }
        ]
      }
    ]
  }
]

export const defaultElementStyle = {
  backgroundColor: '#FFF',
  fontSize: '14px',
  fontFamily: 'Arial, Helvetica, sans-serif',
  fontWeight: 'normal',
  fontStyle: 'normal',
  color: '#000',
  justifyContent: 'flex-start',
  paddingTop: 0,
  paddingRight: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0
}

export const defaultImageStyle = {
  justifyContent: 'center',
  alignItems: 'center'
}

export const defaultTitleStyle = {
  backgroundColor: '#F2F7FA',
  fontSize: '18px',
  fontFamily: 'Arial, Helvetica, sans-serif',
  fontWeight: 'bold',
  fontStyle: 'normal',
  color: '#2369a3',
  justifyContent: 'center'
}

export const defaultBlocStyle = {
  column: {
    fontSize: '14px',
    fontFamily: 'Arial, Helvetica, sans-serif',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#444444',
    justifyContent: 'flex-end'
  },
  value: {
    fontSize: '16px',
    fontFamily: 'Arial, Helvetica, sans-serif',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#2b3085',
    justifyContent: 'flex-start'
  }

}

export const defaultBlocElementStyle = {
  marginTop: 0,
  marginBottom: 0,
  marginRight: 0,
  marginLeft: 0
}

export const defaultWrapperStyle = {
  paddingTop: 0,
  paddingRight: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  backgroundColor: '#fff',
  marginTop: 50,
  marginBottom: 50,
  borderWidth: '0 0 0 0',
  borderColor: '#000',
  borderStyle: 'solid',
  alignItems: 'flex-start'
}



// WEBPACK FOOTER //
// ./src/config/constanteUse.js